import React, { Component } from 'react';
import { translate } from '../Services/translation';
import { activeCustomerAddress } from '../actions/Bahag.action';
import { connect } from 'react-redux';

class BahagDelivery extends Component {

    constructor(props) {
        super(props);
        this.goToCustomerAddress = this.goToCustomerAddress.bind(this);
    }

    renderDeliverySection() {
        return (
            <>
                <div className='germany-section__container'>
                    <h3 className="checkout__section-title">{translate('checkout.bahag.delivery.header')}</h3>
                    <div className="germany-section__delivery">
                        <div className='germany-section__delivery-container'>

                            <label>
                                <input className="germany-section__delivery-container--radio" type="radio" name="custom-radio" defaultChecked />
                                <div className="germany-section__delivery-container--custom-radio">
                                    <div className="inner-circle"></div>
                                </div>
                            </label>

                            <div className="germany-section__delivery-container--text">
                                <p className="germany-section__delivery-container--text--title">{translate("checkout.bahag.delivery.method.title")}</p>
                                <p className="germany-section__delivery-container--text--time">{translate("checkout.bahag.delivery.method.time")}</p>
                                <p className="germany-section__delivery-container--text--shipping">{translate("checkout.bahag.delivery.method.free.shpping.text")}</p>
                                {/*<p className="germany-section__delivery-container--text--price">{translate("checkout.bahag.delivery.method.price")}</p>*/}
                            </div>
                            <div className="germany-section__delivery-container--icon">
                                <span></span>
                            </div>
                        </div>
                        <button onClick={this.goToCustomerAddress} className="germany-section__delivery-container--button">{translate("checkout.bahag.delivery.method.button")}</button>
                    </div>
                    <div className='germany-checkout-cartArrow'></div>
                </div>
            </>
        )
    }

    goToCustomerAddress() {
        const bahagCustomerAddress = document.getElementById("bahag-customer-address");
        if (bahagCustomerAddress) {
            this.props.activeCustomerAddress(true);
            bahagCustomerAddress.scrollIntoView({ behavior: 'smooth' });
        }
    }

    render() {
        return (
            <div id="bahag-delivery">
                {this.renderDeliverySection()}
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch) => ({
    activeCustomerAddress: (isActive) => dispatch(activeCustomerAddress(isActive)),
});

const mapStateToProps = state => {
    return {
        customerInfo: state.bahag.customerInfo,
        cartOrderRows: state.cart.orderRows,
        isActiveDeliverySection: state.bahag.isActiveDeliverySection,
        authorizationHybris: state.bahag.authorizationHybris,
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(BahagDelivery);
